export default __webpack_public_path__ + "static/media/4-1.db155cdd.jpg";